import React, { useState, useEffect } from 'react';
import { Table, Button, Modal,Image } from 'antd';
import dayjs from 'dayjs';
import styles from './ExpandTable.module.scss';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api/api';
import eventBus from '../../../../utils/eventBus';

const ExpandedRow = ({ orderId }) => {
    const [expandedData, setExpandedData] = useState([]);
    const navigate = useNavigate();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const handleImageClick = (images) => {
        setSelectedImages(images);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedImages([]);
    };
    const [parentStatus, setParentStatus] = useState();
    const fetchDetails = async () => {
        try {
            const response = await api.getOrderDetails({ orderId: orderId });
            const rawData = response.data;
            setParentStatus(rawData.status);
            const data = Array.isArray(rawData.details)
                ? rawData.details.map((item, index) => ({
                    key: index,
                    skuImages: item.sku,
                    rawImageCount: item.baseImageCount, // 交付底片数
                    finalImageCount: item.finishCount, // 成片图片数
                    note: item.remark,
                    idx: item.idx, // 序列
                    status: item.status,//需求状态
                    id: item.id,//详细需求   
                }))
                : [];
            setExpandedData(data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchDetails(orderId);
    }, [orderId]);

    useEffect(() => {
        fetchDetails(orderId);
      }, [parentStatus]); 

    useEffect(() => {
    const handleStatusUpdate = () => {
        fetchDetails(orderId);
    };
    eventBus.on('statusUpdated', handleStatusUpdate);
    return () => {
        eventBus.off('statusUpdated', handleStatusUpdate);
    };
    }, [orderId]);
    const columns = [
        {
            title: '需求列表',
            dataIndex: 'idx',
            key: 'idx',
            align: 'center',
            width: 100,
            render:(text,record)=>(
                <p>需求-{record.idx}</p>
            )
        },
        {
            title: '源素材',
            dataIndex: 'skuImages',
            key: 'skuImages',
            align: 'center',
            width: 400,
            render: (skuImages) => (
                <div style={{ display: 'flex' }}>
                    {skuImages.slice(0, 3).map((image, i) => (
                        <div style={{ width: '100px', height: '100px', backgroundColor: 'rgb(224,224,224)', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '15px', borderRadius: '12px', overflow: 'hidden', }}>
                            <img
                                key={i}
                                src={image}
                                alt={`源素材 ${i}`}
                                style={{
                                    maxWidth: '100px',
                                    maxHeight: '100px',
                                    // marginRight: '15px',
                                    objectFit: 'contain',
                                    // borderRadius: '12px',
                                    cursor: 'pointer',
                                    display: "block"
                                }}
                                onClick={() => handleImageClick(skuImages)}
                            />
                        </div>
                    ))}
                    {skuImages.length > 3 && (
                        <div
                            onClick={() => handleImageClick(skuImages)}
                            style={{
                                width: '96px',
                                height: '96px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: 'rgba(245, 246, 252, 1)',
                                fontSize: '10px',
                                borderRadius: '12px',
                                cursor: 'pointer',
                            }}
                        >
                            <div onClick={() => handleImageClick(skuImages)} style={{ fontSize: "12px" }}>
                                等{skuImages.length - 3}张
                            </div>
                        </div>
                    )}
                </div>
            ),
        },
        {
            title: '交付底片数',
            dataIndex: 'rawImageCount',
            key: 'rawImageCount',
            align: 'center',
            width: 152,
        },
        {
            title: '交付成片数',
            dataIndex: 'finalImageCount',
            key: 'finalImageCount',
            align: 'center',
            width: 152,
        },
        {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
            // align: 'center',
            width: 400,
            render: (text, record) => {
                const formatNote = record.note.replace(/\n/g, '<br/>');
                return (
                    <div dangerouslySetInnerHTML={{ __html: formatNote }} />
                );
            },
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 152,
            render: (text, record) => {
                const status = record.status;
                if (parentStatus == 2 || parentStatus == 3) {
                    switch (status) {
                        case 0: return <div style={{ display: "flex", justifyContent: 'center', alignItems: "center" }}><img src={require('@assets/images/status_0.png')} alt="" style={{ width: "86px", height: '26px', objectFit:'contain'}} /></div>
                        case 1: return <div style={{ display: "flex", justifyContent: 'center', alignItems: "center" }}><img src={require('@assets/images/status_1.png')} alt="" style={{ width: "86px", height: '26px' , objectFit:'contain'}} /></div>
                        case 2: return <div style={{ display: "flex", justifyContent: 'center', alignItems: "center" }}><img src={require('@assets/images/status_2.png')} alt="" style={{ width: "86px", height: '26px' , objectFit:'contain'}} /></div>
                        case 3: return <div style={{ display: "flex", justifyContent: 'center', alignItems: "center" }}><img src={require('@assets/images/status_3.png')} alt="" style={{ width: "86px", height: '26px' , objectFit:'contain'}} /></div>
                        default: return <div>{''}</div>
                    }
                } else {
                    return '';
                }
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 152,
            render: (text, record) => {
                // if (record.status === '待确认') {
                //     const id = record.orderId;
                //     return (
                //         <>
                //             <Button type="danger" size="small" style={{ marginRight: 8 }} onClick={() => handleConfirm(2, id)}>
                //                 确认
                //             </Button>
                //             <Button type="danger" size="small" onClick={() => handleConfirm(4, id)}>
                //                 拒绝
                //             </Button>
                //         </>
                //     );
                // } else if (record.status === '进行中' || record.status === '已拒绝') {
                //     return <a onClick={() => navigate('/home/homemain/image_service/deliver', { state: record })}>查看图集</a>
                // } else {
                //     return '-';
                // }
                if (parentStatus != 1 && parentStatus != 4) {
                    return (
                        <a onClick={() => navigate('/home/homemain/image_service/skuList', { state: { title: record.idx, id: record.id } })}>查看图集</a>
                    )
                } else {
                    return '';
                }
            },
        },
    ];

    return (
        <>
            <Table columns={columns} dataSource={expandedData} pagination={false} className={styles.table} />
            <Modal
            open={isModalVisible}
            title="查看图片"
            footer={null}
            onCancel={handleModalClose}
            width={'10.2rem'}
            className={styles.modal}
            >
            <div className={styles.modal_container}>
                <div className={styles.modalImages}>
                    {selectedImages.map((image, index) => (
                        <div className={styles.image_bgc}>
                            <Image key={index} src={image} alt={`Image ${index}`} className={styles.modalImage} />
                        </div>
                    ))}
                </div>
                {/* <div className={styles.modal_confirm_btn}>
                    <button className={styles.modalimg_btn} onClick={handleModalClose}>确定</button>
                </div> */}
            </div>
        </Modal>
        </>
    );
};

export default ExpandedRow;